import { logger } from 'utils/logger';
import { naturalSortBy } from 'utils/sort';

export const NATIONAL_CATEGORY_CODE = 'national';
export const nationalCategory = ['National', NATIONAL_CATEGORY_CODE];
const militaryAddresses = [
  ['AE', 'AE'],
  ['AP', 'AP'],
  ['AA', 'AA'],
];

export const arizonaState = ['Arizona', 'AZ'];
const dcState = ['District of Columbia', 'DC'];
const californiaState = ['California', 'CA'];
export const texasState = ['Texas', 'TX'];

export const checkIsTexasState = state => texasState.includes(state);

const states = [
  arizonaState,
  ['Alabama', 'AL'],
  ['Alaska', 'AK'],
  ['Arkansas', 'AR'],
  californiaState,
  ['Colorado', 'CO'],
  ['Connecticut', 'CT'],
  ['Delaware', 'DE'],
  dcState,
  ['Florida', 'FL'],
  ['Georgia', 'GA'],
  ['Hawaii', 'HI'],
  ['Idaho', 'ID'],
  ['Illinois', 'IL'],
  ['Indiana', 'IN'],
  ['Iowa', 'IA'],
  ['Kansas', 'KS'],
  ['Kentucky', 'KY'],
  ['Louisiana', 'LA'],
  ['Maine', 'ME'],
  ['Maryland', 'MD'],
  ['Massachusetts', 'MA'],
  ['Michigan', 'MI'],
  ['Minnesota', 'MN'],
  ['Mississippi', 'MS'],
  ['Missouri', 'MO'],
  ['Montana', 'MT'],
  ['Nebraska', 'NE'],
  ['Nevada', 'NV'],
  ['New Hampshire', 'NH'],
  ['New Jersey', 'NJ'],
  ['New Mexico', 'NM'],
  ['New York', 'NY'],
  ['North Carolina', 'NC'],
  ['North Dakota', 'ND'],
  ['Ohio', 'OH'],
  ['Oklahoma', 'OK'],
  ['Oregon', 'OR'],
  ['Pennsylvania', 'PA'],
  ['Rhode Island', 'RI'],
  ['South Carolina', 'SC'],
  ['South Dakota', 'SD'],
  ['Tennessee', 'TN'],
  texasState,
  ['Utah', 'UT'],
  ['Vermont', 'VT'],
  ['Virginia', 'VA'],
  ['Washington', 'WA'],
  ['West Virginia', 'WV'],
  ['Wisconsin', 'WI'],
  ['Wyoming', 'WY'],
];

export const allStatesWithMilitaryAddresses = [...militaryAddresses, ...states];

export const allStatesWithNationalCategory = [nationalCategory, ...naturalSortBy(states, 0)];

export const getStateName = code => {
  const state = allStatesWithNationalCategory.find(([__, stateCode]) => code === stateCode);

  if (!state) {
    logger.warn(`State with code ${code} not found!`);
  }

  return state ? state[0] : 'N/A';
};

// The 2-digit state FIPS prefix (the first two digits of a 5-digit county FIPS code), keyed by state
// abbreviation. Shared geographic reference data — not specific to any one feature.
export const STATE_FIPS_LENGTH = 2;

export const STATE_FIPS_PREFIX = {
  AL: '01',
  AK: '02',
  AZ: '04',
  AR: '05',
  CA: '06',
  CO: '08',
  CT: '09',
  DE: '10',
  DC: '11',
  FL: '12',
  GA: '13',
  HI: '15',
  ID: '16',
  IL: '17',
  IN: '18',
  IA: '19',
  KS: '20',
  KY: '21',
  LA: '22',
  ME: '23',
  MD: '24',
  MA: '25',
  MI: '26',
  MN: '27',
  MS: '28',
  MO: '29',
  MT: '30',
  NE: '31',
  NV: '32',
  NH: '33',
  NJ: '34',
  NM: '35',
  NY: '36',
  NC: '37',
  ND: '38',
  OH: '39',
  OK: '40',
  OR: '41',
  PA: '42',
  RI: '44',
  SC: '45',
  SD: '46',
  TN: '47',
  TX: '48',
  UT: '49',
  VT: '50',
  VA: '51',
  WA: '53',
  WV: '54',
  WI: '55',
  WY: '56',
};

export default states;
